import { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Android } from 'ui/icons/devices/Android';
import { Apple } from 'ui/icons/devices/Apple';
import { SecondaryButton } from 'ui/button';
import { Box } from 'ui-beta/box';
import JSONTree from 'core/jsonTree';
import { PathForm } from './PathForm';
import { isJsonFileEmpty } from '../utils';
// import { AppleAppSiteAssociationFile } from '../types';

const PathBox = styled(Box)`
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 40px;
`;

const PathSectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px;
`;

const PathConfigName = styled.div`
  font-size: 20px;
`;

const PathTitle = styled.pre`
  margin-top: 10px;
  font-size: 16px;
  font-weight: 600;
  padding: 0;
`;

const PathHelpText = styled.p`
  margin-top: 10px;
  font-weight: 600;
  color: #717171;
`;

const PathTextSection = styled.section`
  flex: 0 1 40%;
  margin-left: 20px;
  max-width: 400px;
`;

const PathFormSection = styled.section`
  flex: 1 0 60%;
  margin-left: 20px;
`;

const FlexContainer = styled.div`
  align-items: end;
  display: flex;
  gap: 5px;
`;

// type Props = {
//   appDomain: string,
//   assetLinks?: object,
//   appleAppSiteAssociationFile?: AppleAppSiteAssociationFile,
//   buttonCTA: string,
//   configLabel: string,
//   configTitle: string,
//   configHelpText?: string,
//   domain: string,
//   platform: string,
// };

export const PathSection = ({
  appDomain = '',
  assetLinks,
  appleAppSiteAssociationFile,
  buttonCTA = '',
  configHelpText,
  configLabel = '',
  configTitle = '',
  domain = '',
  platform = 'apple',
}) => {
  const platformIsApple = platform === 'apple';
  const jsonString = platformIsApple ? appleAppSiteAssociationFile : assetLinks;

  const [showForm, setShowForm] = useState(false);
  const hasJson = !isJsonFileEmpty(jsonString, platformIsApple);
  const showJsonTree = hasJson && !showForm;

  const onConfigureClick = () => {
    setShowForm(true);
  };

  const onCloseForm = useCallback(() => {
    setShowForm(false);
  }, [hasJson]);

  return (
    <PathBox>
      <PathSectionContainer>
        <PathTextSection>
          <FlexContainer>
            {platformIsApple ? <Apple width={20} /> : <Android width={20} />}
            <PathConfigName>{configTitle}</PathConfigName>
          </FlexContainer>
          <PathTitle>{configLabel}</PathTitle>
          {configHelpText && <PathHelpText>{configHelpText}</PathHelpText>}
        </PathTextSection>
        {!showForm && (
          <SecondaryButton platform={platform} onClick={onConfigureClick}>
            {buttonCTA}
          </SecondaryButton>
        )}
        {showForm && (
          <PathFormSection>
            <PathForm
              jsonString={jsonString}
              appDomain={appDomain}
              domain={domain}
              platform={platform}
              onClose={onCloseForm}
            />
          </PathFormSection>
        )}
      </PathSectionContainer>
      {showJsonTree && (
        <PathSectionContainer>
          <JSONTree src={jsonString} rootName={null} />
        </PathSectionContainer>
      )}
    </PathBox>
  );
};

export default PathSection;
